import { render, staticRenderFns } from "./lectures.vue?vue&type=template&id=73a7c555&scoped=true&"
import script from "./lectures.vue?vue&type=script&lang=js&"
export * from "./lectures.vue?vue&type=script&lang=js&"
import style0 from "./lectures.vue?vue&type=style&index=0&id=73a7c555&lang=scss&scoped=true&"
import style1 from "./lectures.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7c555",
  null
  
)

export default component.exports